// src/pages/Services.js
// Page catégorie Services - NE PAS MODIFIER

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import ListingGrid from '../components/listing/ListingGrid';
import CategoryBar from '../components/home/CategoryBar';
import { useListings } from '../hooks/useListings';

const Services = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { loading } = useListings();
  const [listings, setListings] = useState([]);

  useEffect(() => {
    const demoListings = [
      {
        id: 6,
        slug: 'service-nettoyage-douala-6',
        title: 'Service de nettoyage professionnel',
        quartier: 'Akwa',
        city: 'Douala',
        price: 15000,
        priceType: 'service',
        category: 'services',
        images: ['/images/placeholder.png'],
      },
      {
        id: 8,
        slug: 'service-demenagement-douala-8',
        title: 'Déménagement rapide et sécurisé',
        quartier: 'Bonapriso',
        city: 'Douala',
        price: 50000,
        priceType: 'service',
        category: 'services',
        images: ['/images/placeholder.png'],
      },
    ];
    setListings(demoListings);
  }, []);

  const styles = {
    container: { display: 'flex', flexDirection: 'column', minHeight: '100vh' },
    header: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '16px',
      position: 'sticky',
      top: 0,
      backgroundColor: '#0A0E1A',
      zIndex: 50,
      borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    },
    backButton: {
      background: 'none',
      border: 'none',
      color: '#FFFFFF',
      fontSize: '20px',
      cursor: 'pointer',
      padding: '4px',
    },
    title: { fontSize: '20px', fontWeight: '700', color: '#FFFFFF' },
    subtitle: { padding: '8px 16px', fontSize: '14px', color: '#A0AEC0' },
  };

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Services immobiliers au Cameroun | Fynho</title>
        <meta name="description" content="Nettoyage, déménagement, rénovation, sécurité et plus. Trouvez des services de qualité au Cameroun." />
        <meta name="keywords" content="service nettoyage Douala, déménagement Cameroun, rénovation, sécurité, services immobiliers" />
        <link rel="canonical" href="https://fynho.com/services" />
      </Helmet>

      <div style={styles.header}>
        <button style={styles.backButton} onClick={() => navigate('/')}>←</button>
        <div style={styles.title}>🛎️ {t('categories.services')}</div>
      </div>

      <CategoryBar />

      <div style={styles.subtitle}>
        Nettoyage, déménagement, rénovation · {listings.length} services
      </div>

      <ListingGrid listings={listings} loading={loading} />
    </div>
  );
};

export default Services;